import CloseButton from './CloseButton.styles'
export default CloseButton



// WEBPACK FOOTER //
// ./src/components/CloseButton/index.js